import React from 'react'

const YoutubeEmbed = ({ embedId }) => (
      <div className="yt-video">
        <iframe
            src={`https://www.youtube.com/embed/${embedId}`}
            width="635"
            height="310"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title = {`Gameplay video: ${embedId}`}
        />
        </div>
)

export default YoutubeEmbed;